import { ExpressionRealNodePreview } from "@/components/expression/preview/ExpressionNodePreview";
import { twMerge } from "@/utils/twMerge";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeModel } from "@/models/nodes/types";

type Props = {
  doc: DocumentModel;
  nodes: NodeModel[];
  className?: string;
};

export function MathThemePreview({ doc, nodes, className }: Props) {
  return (
    <div className={twMerge("flex gap-1", className)}>
      {nodes.map((node) => (
        <ExpressionRealNodePreview key={node.id} node={node} doc={doc} />
      ))}
    </div>
  );
}
